import React, { Suspense } from 'react';
import { Route, Switch, Router } from 'react-router-dom';
import UserProfile from './Profile_V2';
import { injectAppHistory } from '@wolffun/app-manager';
import { RouteName } from './utils/types';
import { reducers } from './redux/reducers';

const App = ({
  history,
  store
}) => {
  store.injectReducer(reducers);
  injectAppHistory(history);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: RouteName.Profile,
    component: UserProfile
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: () => /*#__PURE__*/React.createElement("div", null, "Not found")
  }))));
};

export default App;